<template>
  <div id="contenedor-auditoria-contratos-toolbar">
    <v-toolbar
    flat
    dense>
    <v-spacer></v-spacer>
    <custom-button
      v-if="mixValidaScopesActions(1)"
      label="Nuevo"
      iconText="mdi-plus"
      tipo="agregar"
      @click="nuevo">
    </custom-button>
  </v-toolbar>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'AuditoriaContratosToolBar',
  props: {
    filtros: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      debounce: null,
    };
  },
  methods: {
    nuevo() {
      this.$emit('nuevoAuditoriaContratos');
    },
  },

};
</script>

<style lang="scss">

</style>
